export const RESTRICTED_TRIAL_COLUMNS_MAP: Record<string, string> = {
  last_name: 'last_name',
  email: 'email',
  personal_email: 'personal_email',
  phone_number: 'phone_number',
  linkedin_url: 'linkedin_url',
};

export const RESTRICTED_TRIAL_COLUMNS = new Set(
  Object.keys(RESTRICTED_TRIAL_COLUMNS_MAP)
);
